import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Button, Modal } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useEffect, useRef } from 'react';
import { useAction, useAsyncState } from '@hooks';

const { confirm } = Modal;

export interface ArchiveButtonProps {
	initiativeId: number;
}

const deleteSelectors = createAsyncSelectors((state) => state.core.initiatives.byId.delete);

export const ArchiveButton: React.FC<ArchiveButtonProps> = ({ initiativeId }) => {
	const navigate = useNavigate();
	const { isRequested, isReceived } = useAsyncState(deleteSelectors);
	const deleteInitiative = useAction(coreActions.requestDeleteCoreInitiativesById);

	const modalRef = useRef<{ destroy:() => void }>();

	useEffect(() => {
		if (isReceived) {
			modalRef.current?.destroy();
			navigate(FULL_ROUTES.INITIATIVES);
		}
	}, [ isReceived, navigate ]);

	const handleArchive = () => {
		modalRef.current = confirm({
			cancelText: COPY_GENERIC.CANCEL,
			content: COPY_SPECIFIC.ARE_YOU_SURE_ARCHIVE_INITIATVE,
			icon: <ExclamationCircleOutlined />,
			okText: COPY_GENERIC.CONFIRM,
			okType: 'danger',
			onOk: () => deleteInitiative({ id: initiativeId }),
			title: COPY_SPECIFIC.ARCHIVE_INITIATIVE
		});
	};

	return (
		<Button
			danger
			id='initiative-archive-button'
			loading={ isRequested }
			onClick={ handleArchive }
			type='text'>
			{ COPY_SPECIFIC.ARCHIVE_INITIATIVE }
		</Button>
	);
};
